import { useState } from 'react';
import { Dropdown, Menu } from 'antd';
import { MenuOutlined } from '@ant-design/icons';

import './customStyles.scss';

const MobileDrawer = () => {
    const [visible, setVisible] = useState(false);
    const subMenu = (
        <Menu onClick={() => setVisible(false)}>
            <Menu.Item key="trading">
                <a href="#trading">Trading</a>
            </Menu.Item>
            <Menu.Item key="solutions">
                <a href="#solutions">Solutions</a>
            </Menu.Item>
            <Menu.Item key="commodities">
                < a href="#commodities">Commodities</a>
            </Menu.Item>
        </Menu>
    )
    const menu = (
        <Menu
            className='dropdown-menu'
            onClick={(info) => {
                if (info.key !== 'whatWeOffer') {
                    setVisible(false);
                }
            }}
            theme='dark'
        >
            <Menu.Item key={1}>
                <a href='#banner'>Home</a>
            </Menu.Item>
            <Menu.Item key={2}>
                <Dropdown overlay={subMenu} trigger={['click']}>
                    <a
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation(); // 🔥 prevents parent menu from closing
                        }}
                    >
                        What We Offer
                    </a>
                </Dropdown>
            </Menu.Item>
            <Menu.Item key={3}>
                <a href='#team'>Management Team</a>
            </Menu.Item>
            <Menu.Item key={4}>
                <a href='#pthead'>Engagements</a>
            </Menu.Item>
            <Menu.Item key={6}>
                <a href='https://vikasbandhu.in/terms&conditions'>Terms</a>
            </Menu.Item>
            <Menu.Item key={7}>
                <a href='#contact'>Contact Us</a>
            </Menu.Item>
            <Menu.Item key={9}>
                <a href='#articles'>Tech Corner</a>
            </Menu.Item>
        </Menu>
    );

    return (
        <div className='mobile-visible'>
            <Dropdown
                className='mobile-dropdown'
                trigger={['click']}
                overlay={menu}
                onVisibleChange={() => setVisible(!visible)}
                visible={visible}
            >
                <MenuOutlined style={{ fontSize: '1.5rem' }} />
            </Dropdown>
        </div>
    );
};

export default MobileDrawer;
